import { array, struct } from 'io-ts/Decoder';

import { RequestItem } from './RequestItem';

export const Request = struct({
	files: array(RequestItem),
});
